import { CheckCategory } from '@src/state/document/types'
import { CheckTabsVisited } from '@src/state/workspace/reducer'
import { TabData } from '@src/state/workspace/selectors'
import { Device } from '@src/styled/media'
import { LinkProps } from 'react-router-dom'

export interface MediaProps {
  media: Device
}

export interface TabProps extends TabData, MediaProps {
  onClick?: () => void
  onUserClick: (category: CheckCategory, displayText: string) => void
  similarityScore?: number
  visited?: boolean
  hasZohoCookie?: boolean
  path: string
  isActive: boolean
  id?: string
  currentCheckCategory: CheckCategory
  checkTabsVisited: CheckTabsVisited
}

export type TabNotificationProps = Pick<
  TabProps,
  'count' | 'similarityScore' | 'category' | 'visited'
>

export type TabMarkup = Pick<TabProps, 'onClick' | 'isActive' | 'media' | 'id'> &
  LinkProps

export interface StateMappedToProps {
  currentCheckCategory: CheckCategory
  tabData: TabData[]
  hasZohoCookie: boolean
  ecPageSlug: string
  isDemo: boolean
}

export type ComponentProps = StateMappedToProps & MediaProps

export const GRAMMAR_SLUG = '' as const
export const PLAGIARISM_SLUG = '/plagiarism' as const
export const EC_BASE_SLUG = '/expert-check' as const

export const GRAMMAR_DISPLAY = 'Grammar'
export const PLAGIARISM_DISPLAY = 'Plagiarism'
export const EXPERT_CHECK_DISPLAY = 'Expert Check'



// WEBPACK FOOTER //
// ./src/layouts/shared/NavTabs/types.ts